import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Tooltip } from "@fluentui/react-components";
import { InfoSparkleRegular } from "@fluentui/react-icons";
import { Duration } from "luxon";
import { useEffect, useState } from "react";

import { appInfoGet } from "../../../services/api.service.js";
import { env } from "../../../utils/env.js";
import { recordErrorInSentry } from "../../../utils/init-sentry.js";

const UPDATE_INTERVAL_MS = Duration.fromObject({ minutes: 5 }).as(
  "milliseconds"
);

export const NewVersionAvailableNotification = () => {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        const info = await appInfoGet();
        if (info.version !== env.PUBLIC_APPLICATION_VERSION) {
          setShowNotification(true);
        }
      } catch (error) {
        recordErrorInSentry(error);
        console.error("Failed to fetch app info:", error);
      }
    }, UPDATE_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const handleClick = useStableCallback(() => window.location.reload());

  if (!showNotification) {
    return null;
  }

  return (
    <Tooltip
      content="A new version is available. Click to update."
      relationship="description"
    >
      <button
        className="bg-bzd-yellow-400 absolute top-5 right-45 z-50 flex cursor-pointer items-center rounded-md px-4 py-1.5 transition-colors hover:animate-pulse"
        data-new-version-available-notification
        onClick={handleClick}
        type="button"
      >
        <InfoSparkleRegular className="mr-2" />
        Update
      </button>
    </Tooltip>
  );
};
